import React from 'react'
import Login from './components/auth/Login'
import Register from './components/auth/Register'
import Users from './components/Users'
import Play from './components/Play'
import { Route, Routes } from 'react-router-dom'
import { AuthContextProvider } from './context/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Faq from './components/Faq'
import AddPasukan from './components/pasukan/Tambah';
import ViewPasukan from './components/pasukan/Lihat';
import AirdropMenu from './components/airdrop/Menu';
import GarapAirdrop from './components/airdrop/Garap';
import Garapan from './components/airdrop/Garapan';
import Wallet from './components/wallet/Manage';
import WalletAdd from './components/wallet/Add';
import Upgrade from './components/upgrade/Subscribe';
import GarapPro from './components/garap/pro/Main';

function App() {
  return (
    <div className="App">
      <AuthContextProvider>
        <Routes>
          <Route path="/" element={
          <ProtectedRoute><Users /></ProtectedRoute>} />
          <Route path="/pasukan/add" element={
          <ProtectedRoute><AddPasukan /></ProtectedRoute>} />
          <Route path="/pasukan/view" element={
          <ProtectedRoute><ViewPasukan /></ProtectedRoute>} />
          <Route path="/airdrop" element={
          <ProtectedRoute><AirdropMenu /></ProtectedRoute>} />
          <Route path="/airdrop/do" element={
          <ProtectedRoute><GarapAirdrop /></ProtectedRoute>} />
          <Route path="/airdrop/view" element={
          <ProtectedRoute><Garapan /></ProtectedRoute>} />
          <Route path="/myWalletList" element={
          <ProtectedRoute><Wallet /></ProtectedRoute>} />
          <Route path="/wallet/add" element={
          <ProtectedRoute><WalletAdd /></ProtectedRoute>} />
          <Route path="/upgrade" element={
          <ProtectedRoute><Upgrade /></ProtectedRoute>} />
          <Route path="/pro" element={
          <ProtectedRoute><GarapPro /></ProtectedRoute>} />
          <Route path="/play" element={<Play />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Register />} />
        </Routes>
      </AuthContextProvider>
    </div>
  );
}

export default App;
